import React from 'react';
import './viewTransactionsPage.scss';
import ViewTransactionsGrid from './viewTransactionsGrid/ViewTransactionsGridConnector';

const title = `View Transactions`;

class ViewTransactionsPage extends React.Component {
  componentWillMount() {
    document.title = title;
  }

  render() {
    return (
      <div className="view-transaction-page">
        <h1>{ title }</h1>
        <hr />
        <ViewTransactionsGrid />
      </div>
    );
  }
}

export default ViewTransactionsPage;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/ViewTransactionsPage.js